import { HttpClient, serializeJSONApiData } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const typer = (type, identifier) =>
  type && identifier ? `${type}/${identifier}/` : ''

const postWorkflowPhaseItem = ({
  type,
  identifier,
  workflowId,
  phaseId,
  params,
}) =>
  HttpClient().post(
    `/api/v1/${typer(
      type,
      identifier
    )}workflow/${workflowId}/phases/${phaseId}/phase_items`,
    { data: params.data }
  )

const createWorkflowPhaseItem =
  ({ identifier, itemId, phaseId, type, update, workflowId }) =>
  (dispatch) => {
    const params = serializeJSONApiData('phase-items', { ...update }, true)

    return postWorkflowPhaseItem({
      identifier,
      itemId,
      params,
      phaseId,
      type,
      workflowId,
    })
      .then((response) => dispatch(loadWorkflow(response.data)))
      .catch((err) => {
        console.log(err)
        throw err
      })
  }

export default createWorkflowPhaseItem
